var _rect, _path, _path2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#3E7AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.88178V6.667C6 6.35647 6.25174 6.10474 6.56227 6.10474H8.84078C9.34557 6.10474 9.59465 6.71835 9.23269 7.07019L6.95417 9.28496C6.59772 9.63143 6 9.37887 6 8.88178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.1182V18.333C19 18.6435 18.7482 18.8953 18.4377 18.8953H16.1592C15.6544 18.8953 15.4053 18.2816 15.7673 17.9298L18.0458 15.715C18.4023 15.3686 19 15.6211 19 16.1182Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9837,
    cy: 10.1212,
    rx: 4.0162,
    ry: 4.0162,
    fill: "white",
    fillOpacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0162,
    cy: 14.879,
    rx: 4.0162,
    ry: 4.0162,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapActive);
export default __webpack_public_path__ + "static/media/swap_active.48785c466f701a62db245ee52395d69b.svg";
export { ForwardRef as ReactComponent };